<app-modal-header
  title="Profile"
  (closeModal)="closeDialog()"
></app-modal-header>

<div class="bg-white flex flex-row justify-between p-5">
  <div *ngIf="isLoading" class="loading-indicator">Loading...</div>

  <div
    *ngIf="!isLoading && userProfile"
    class="w-full flex justify-between items-center space-x-6"
  >
    <div class="flex-shrink-0 relative group">
      <div class="cursor-pointer relative" (click)="fileInput.click()">
        <div
          *ngIf="uploadingImage"
          class="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-60 rounded-full"
        >
          <div
            class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
          ></div>
        </div>

        <img
          [src]="userProfile.photo || 'assets/images/avatar.svg'"
          alt="User Profile"
          class="w-32 h-32 rounded-full object-cover shadow-md border-2 border-transparent group-hover:border-blue-500 transition-all"
          [class.opacity-50]="uploadingImage"
        />

        <div
          class="absolute inset-0 bg-black bg-opacity-40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <span class="text-white text-xs font-medium">Change Photo</span>
        </div>
      </div>

      <input
        #fileInput
        type="file"
        (change)="onFileSelected($event)"
        (click)="$event.stopPropagation()"
        accept="image/*"
        style="display: none"
      />
    </div>

    <div class="flex-grow">
      <form [formGroup]="form" (ngSubmit)="updateUserData()">
        <h1 class="mb-4">
          <strong
            >{{ userProfile.firstName }} {{ userProfile.lastName }}</strong
          >
        </h1>
        <div class="inline-block mb-4">
          <span
            class="px-3 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700"
          >
            {{ userProfile.accountType }}
          </span>
        </div>

        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">First Name</label>
          <input
            formControlName="firstName"
            type="text"
            class="w-full px-4 py-2 border rounded"
          />
        </div>

        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">Last Name</label>
          <input
            formControlName="lastName"
            type="text"
            class="w-full px-4 py-2 border rounded"
          />
        </div>

        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">Email</label>
          <input
            formControlName="email"
            type="email"
            class="w-full px-4 py-2 border rounded bg-gray-100 cursor-not-allowed"
          />
        </div>

        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">Phone</label>
          <input
            formControlName="phone"
            type="text"
            class="w-full px-4 py-2 border rounded"
          />
        </div>

        <div class="flex justify-between items-center">
          <button
            type="button"
            (click)="downloadUserManual()"
            class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
          >
             User Manual
          </button>
          <button
            type="submit"
            [disabled]="form.invalid || isLoading"
            class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="!isLoading && !userProfile" class="mt-4 text-red-500">
    User not found or failed to load.
  </div>
</div>
